import { tw } from "@careinfo/tailwind";
import APIS from "../../../constant/Endpoint";
import useGetHook from "../../../customHooks/useGetHook";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";

export default ({ selectedOrder }) => {
  return (
    <div>
      <div className={tw`border-b-2 border-gray-200 pt-5`}>
        <h4 className={tw`text-lg font-bold`}>Documents</h4>
      </div>
      <div className={tw`max-h-[400px] overflow-y-auto`}>
        <FileUpload object_id={selectedOrder} />
      </div>
    </div>
  );
};
